import React, { useState, useEffect, useRef } from 'react'

export default function CustomMapComponent({ dealerData, TextType, totalHeight, showTotalDealer = false, mapType = "dealerwise" }) {
    console.log("dealerData", dealerData);
    const mapContainer = useRef(null);
    const mapRef = useRef(null);
    const markersRef = useRef([]);
    const [mapLoaded, setMapLoaded] = useState(false);

    // AWS Location Service API Key
    const AWS_API_KEY = "v1.public.eyJqdGkiOiJmY2M2ZjJkZi0xZjkxLTQ5YWEtOGQ2Ny1iNTFmOWZkMzM5MzkifVByT_rHr_snf5euU2hmnKAVWaYpcVKMC97aPm9dLQLiVJQUVz4vHuyxU1zY-hBGaU0b6njDqa0lL_p6uetF1Qp18LBZJrb06wSHW1cpmTkTceUkLFyM7siWkiTTpa4yl-LIVXrrmT-C_5GkalWq6XtL-sRyU01e9N51AIWW1aGulFFxPv2wosim02ckyX0voRGeMNzDSMxLQFDXq2kQVRSKEunobfWreQf_8eKn0LyNVyKYe7ggDdO-c-HSNMMZfpGQNOKbH8hhp-jUl4UIHxn5jM0F6l4gEKWbGidj_9vsyq3Y8mZ-9jsCWR4WXuIPuaaV_7mreATOlx-pWVDYgFo.Njg1MGZlZTUtYTI2ZS00MDdlLWJjNDktMDNmZDlkNzVmMjQ0";
    const region = "ap-south-1";
    const style = "Standard";
    const colorScheme = "Light";

    useEffect(() => {
        let mapInstance = null;

        const loadMap = async () => {
            // Check if MapLibre is already loaded
            if (window.maplibregl) {
                initMap();
                return;
            }

            // Load MapLibre CSS
            if (!document.querySelector('link[href*="maplibre-gl.css"]')) {
                const link = document.createElement("link");
                link.href = "https://unpkg.com/maplibre-gl@3.x/dist/maplibre-gl.css";
                link.rel = "stylesheet";
                document.head.appendChild(link);
            }

            // Load MapLibre JS
            if (!document.querySelector('script[src*="maplibre-gl.js"]')) {
                const script = document.createElement("script");
                script.src = "https://unpkg.com/maplibre-gl@3.x/dist/maplibre-gl.js";
                script.onload = initMap;
                document.body.appendChild(script);
            }
        };

        const initMap = () => {
            // Check if maplibregl is loaded
            if (!window.maplibregl) {
                console.error('MapLibre GL not loaded');
                return;
            }

            // Check if container exists
            if (!mapContainer.current) {
                console.error('Map container not found');
                return;
            }

            // Prevent multiple map instances
            if (mapRef.current) {
                console.log('Map already initialized');
                return;
            }

            const maplibregl = window.maplibregl;

            try {
                // AWS Location Service style endpoint
                const styleUrl = `https://maps.geo.${region}.amazonaws.com/v2/styles/${style}/descriptor?key=${AWS_API_KEY}&color-scheme=${colorScheme}`;

                mapInstance = new maplibregl.Map({
                    container: mapContainer.current,
                    style: styleUrl,
                    center: [78.9629, 20.5937], // India center
                    zoom: 4.5,
                    minZoom: 3,
                    maxZoom: 18,
                    // Explicitly enable all interactions
                    dragPan: true,
                    scrollZoom: true,
                    boxZoom: true,
                    dragRotate: false, // Disable rotation for better UX
                    keyboard: true,
                    doubleClickZoom: true,
                    touchZoomRotate: true,
                    touchPitch: false
                });

                // Add zoom and navigation controls
                mapInstance.addControl(new maplibregl.NavigationControl({
                    showCompass: false,
                    showZoom: true,
                    visualizePitch: false
                }), "top-right");

                // Add fullscreen control
                mapInstance.addControl(new maplibregl.FullscreenControl(), "top-right");

                // Handle map load event
                mapInstance.on('load', () => {
                    console.log('✓ Map loaded successfully and ready for interaction');
                    setMapLoaded(true);
                });

                // Handle map errors
                mapInstance.on('error', (e) => {
                    console.error('Map error:', e);
                });

                // Add drag event listeners to verify dragging works
                mapInstance.on('dragstart', () => {
                    console.log('Map drag started');
                });

                mapInstance.on('dragend', () => {
                    console.log('Map drag ended');
                });

                // Add zoom event listeners
                mapInstance.on('zoomstart', () => {
                    console.log('Zoom started');
                });

                mapInstance.on('zoomend', () => {
                    console.log('Zoom ended, current zoom:', mapInstance.getZoom());
                });

                mapRef.current = mapInstance;
            } catch (error) {
                console.error('Error initializing map:', error);
            }
        };

        loadMap();

        // Cleanup function
        return () => {
            if (mapRef.current) {
                console.log('Cleaning up map');
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, []);


    useEffect(() => {
        if (!mapRef.current || !mapLoaded || !dealerData?.length) {
            console.log('Skipping marker update:', {
                hasMap: !!mapRef.current,
                mapLoaded,
                dealerCount: dealerData?.length
            });
            return;
        }

        const maplibregl = window.maplibregl;
        if (!maplibregl) {
            console.error('MapLibre GL not available');
            return;
        }

        console.log('Adding markers for', dealerData.length, 'dealers');

        // Clear existing markers
        markersRef.current.forEach(marker => {
            marker.remove();
        });
        markersRef.current = [];

        let validMarkerCount = 0;

        // Add new markers
        dealerData.forEach((dealer, index) => {
            const lat = parseFloat(dealer?.latitude);
            const lng = parseFloat(dealer?.longitude);

            console.log(`Dealer ${index + 1}:`, {
                name: dealer.dealerName,
                lat,
                lng,
                isValid: lat && lng && lat !== 0 && lng !== 0
            });

            // Skip invalid coordinates
            if (!lat || !lng || lat === 0 || lng === 0 || isNaN(lat) || isNaN(lng)) {
                console.warn(`Invalid coordinates for dealer: ${dealer.dealerName}`, { lat, lng });
                return;
            }

            // Validate lat/lng ranges
            if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
                console.warn(`Out of range coordinates for dealer: ${dealer.dealerName}`, { lat, lng });
                return;
            }

            // Create marker element
            const el = document.createElement("div");
            el.className = "custom-marker";
            el.style.backgroundColor = dealer.color || "#ffa600ff";
            el.style.width = mapType == "all" ? "26px" : "24px";
            el.style.height = mapType == "all" ? "26px" : "24px";
            el.style.borderRadius = "50%";
            el.style.cursor = "pointer";
            el.style.border = "3px solid white";
            el.style.boxShadow = "0 2px 8px rgba(0,0,0,0.4)";
            el.style.transition = "all 0.2s ease";
            el.style.display = "flex";
            el.style.alignItems = "center";
            el.style.justifyContent = "center";

            // Create popup content with better styling
            const popupContent = `
                <div style="font-family: Arial, sans-serif; font-size: 13px; padding: 10px; min-width: 220px;">
                    <div style="font-weight: bold; margin-bottom: 10px; color: #1d3557; font-size: 15px; border-bottom: 2px solid #ffa600; padding-bottom: 5px;">
                        ${dealer.dealerName}
                    </div>
                    ${dealer.city || dealer.state ? `<div style="margin-bottom: 8px; color: #666; font-size: 12px;">
                        📍 ${dealer.city}${dealer.city && dealer.state ? ', ' : ''}${dealer.state}
                    </div>` : ''}
                    ${dealer.dealerEmail ? `<div style="margin-bottom: 5px; word-break: break-all;">
                        <span style="font-weight: 600;">📧 Email:</span> ${dealer.dealerEmail}
                    </div>` : ''}
                    ${dealer.dealerMobile ? `<div style="margin-bottom: 5px;">
                        <span style="font-weight: 600;">📱 Mobile:</span> ${dealer.dealerMobile}
                    </div>` : ''}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Total Count: ${dealer.totalCount || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Conversion Rate: ${dealer.conversionRate || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Additional Review: ${dealer.additionalReviewCount || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 BRE Approved: ${dealer.breApprovedCount || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Rejected: ${dealer.rejectedCount || 0}
                    </div>` }
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Loan: ${dealer.loanCount || 0}
                    </div>`}
                </div>
            `;

            const AllPopupContent = `
                <div style="font-family: Arial, sans-serif; font-size: 13px; padding: 10px; min-width: 220px;">
                    <div style="font-weight: bold; margin-bottom: 10px; color: #1d3557; font-size: 15px; border-bottom: 2px solid #ffa600; padding-bottom: 5px;">
                       📍 ${dealer?.state} (${dealer?.count})
                    </div>
                   
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Total Dealers: ${dealer?.dealers || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Total Urja Agents: ${dealer?.amuAgents || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Conversion Rate: ${dealer.conversionRate || 0} 
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Additional Review: ${dealer.additionalReviewCount || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 BRE Approved: ${dealer.breApprovedCount || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Rejected: ${dealer.rejectedCount || 0}
                    </div>` }
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Loan: ${dealer.loanCount || 0}
                    </div>`}
                </div>
            `;

            const HubPopupContent = `
                <div style="font-family: Arial, sans-serif; font-size: 13px; padding: 10px; min-width: 220px;">
                    <div style="font-weight: bold; margin-bottom: 10px; color: #1d3557; font-size: 15px; border-bottom: 2px solid #ffa600; padding-bottom: 5px;">
                        ${dealer?.name}
                    </div>
                    ${dealer.city || dealer.state ? `<div style="margin-bottom: 8px; color: #666; font-size: 12px;">
                        📍 ${dealer.city}${dealer.city && dealer.state ? ', ' : ''}${dealer.state}
                    </div>` : ''}
                    
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Total Leads: ${dealer?.totalLeads || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Converted Leads: ${dealer?.convertedLeads || 0}
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Conversion Rate: ${dealer?.conversionRate || 0}%
                    </div>`}
                    ${`<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-weight: 600; color: #064254;">
                        📊 Active Status: ${dealer?.status == true || dealer?.status == "true" ? "Yes" : "No"}
                    </div>`}
                   
                </div>
            `;
           

            try {
                // Create and add marker first WITHOUT popup
                const marker = new maplibregl.Marker({
                    element: el,
                    anchor: 'center'
                })
                    .setLngLat([lng, lat])
                    .addTo(mapRef.current);

                // Create popup and bind it to marker
                const popup = new maplibregl.Popup({
                    offset: 30,
                    closeButton: true,
                    closeOnClick: false,
                    maxWidth: '320px',
                    className: 'custom-popup'
                }).setHTML(mapType == "all" ? AllPopupContent : mapType =="HubData" ? HubPopupContent : popupContent);

                // Set the popup on the marker
                marker.setPopup(popup);

                let leaveTimeout;

                // Hover effect - show popup on hover
                el.addEventListener('mouseenter', function (e) {
                    // el.style.transform = "scale(1.3)";
                    el.style.zIndex = "1000";

                    // Open popup
                    popup.setLngLat([lng, lat]).addTo(mapRef.current);
                    console.log('Popup opened on hover at', [lng, lat]);
                });

                // Mouse leave - close popup after a short delay
                el.addEventListener('mouseleave', function (e) {
                    // el.style.transform = "scale(1)";
                    el.style.zIndex = "auto";

                    // Small delay before closing
                    leaveTimeout = setTimeout(() => {
                        popup.remove();
                        console.log('Popup closed on leave');
                    }, 300);
                });

                // Popup event - keep open when hovering
                popup.on('open', function () {
                    const popupEl = popup.getElement();
                    if (popupEl) {
                        popupEl.addEventListener('mouseenter', function () {
                            clearTimeout(leaveTimeout);
                        });

                        popupEl.addEventListener('mouseleave', function () {
                            popup.remove();
                        });
                    }
                });

                // Click to toggle popup (keep it open permanently)
                el.addEventListener('click', function (e) {
                    e.stopPropagation();
                    clearTimeout(leaveTimeout);
                    marker.togglePopup();
                    console.log('Popup toggled on click');
                });

                markersRef.current.push(marker);
                validMarkerCount++;

                console.log(`✓ Marker ${validMarkerCount} added at [${lng}, ${lat}]`);
            } catch (error) {
                console.error('Error adding marker:', error, dealer);
            }
        });

        console.log(`✓ Total markers added: ${validMarkerCount} out of ${dealerData.length}`);

        // Fit bounds to show all markers if there are any
        if (markersRef.current.length > 0 && markersRef.current.length <= 100) {
            try {
                const bounds = new maplibregl.LngLatBounds();
                let boundsCount = 0;

                dealerData.forEach(dealer => {
                    const lat = parseFloat(dealer.latitude);
                    const lng = parseFloat(dealer.longitude);
                    if (lat && lng && lat !== 0 && lng !== 0 && !isNaN(lat) && !isNaN(lng)) {
                        bounds.extend([lng, lat]);
                        boundsCount++;
                    }
                });

                console.log(`Fitting bounds for ${boundsCount} markers`);

                if (!bounds.isEmpty()) {
                    // Add a small delay to ensure map is ready
                    setTimeout(() => {
                        mapRef.current.fitBounds(bounds, {
                            padding: {
                                top: 80,
                                bottom: 80,
                                left: 80,
                                right: 80
                            },
                            maxZoom: 12,
                            duration: 1000
                        });
                    }, 150);
                }
            } catch (error) {
                console.error('Error fitting bounds:', error);
            }
        } else if (markersRef.current.length > 100) {
            console.log('Too many markers to auto-fit bounds, keeping default view');
        } else {
            console.warn('No valid markers to display on map');
        }
    }, [dealerData, mapLoaded]);

    return (
        <div style={{ position: 'relative', width: '100%', height: totalHeight }}>
            <div
                ref={mapContainer}
                style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: '5px',
                    cursor: 'grab',
                    outline: 'none'
                }}
            />
            {!mapLoaded && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'white',
                    padding: '20px 30px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    fontSize: '14px',
                    color: '#666',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        border: '3px solid #f3f3f3',
                        borderTop: '3px solid #064254',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                    Loading map...
                </div>
            )}
            {mapLoaded && dealerData?.length === 0 && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'white',
                    padding: '20px 30px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    fontSize: '14px',
                    color: '#666',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '32px', marginBottom: '10px' }}>📍</div>
                    No {TextType} locations to display
                </div>
            )}
            {mapLoaded && showTotalDealer == true && (
                <div style={{
                    position: 'absolute',
                    bottom: '15px',
                    left: '15px',
                    background: 'white',
                    padding: '8px 12px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                    fontSize: '12px',
                    color: '#666',
                    zIndex: 999
                }}>
                    <div style={{ fontWeight: 'bold', color: '#064254', marginBottom: '3px' }}>
                        Total {TextType}: {dealerData?.filter(d => parseFloat(d.latitude) && parseFloat(d.longitude)).length || 0}
                    </div>
                    <div style={{ fontSize: '11px' }}>
                        💡 Hover markers for info | Click to pin
                    </div>
                </div>
            )}
        </div>
    );
};

